import { useMutation } from '@tanstack/react-query';
import { useState } from 'preact/hooks';
import { GET, GET_USER_INFO } from '../../../../services';

export const useGetUserInfo = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(
        GET_USER_INFO({
          search: search || '',
        }),
      );
      return response.result || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });

  const onFetch = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetch };
};
